


































import { snakeCase } from 'lodash'
import Vue from 'vue'
import i18n from 'vue-i18n'
import { Component, Prop } from 'vue-property-decorator'

import { LabelsActionProxy } from '../../../logic/Actions/LabelsAction/LabelsActionProxy'
import { systemLabelsRecord } from '../../../logic/Actions/LabelsAction/SYSTEM_LABELS'

@Component({
  data() {
    return {
      snakeCase,
    }
  }
})
export default class LabelsAction extends Vue {
  @Prop() action!: LabelsActionProxy

  @Prop() getLabels!: () => { [key: string]: string }

  @Prop() i18n!: i18n

  get frontLabels(): Array<string> {
    return this.action.action.label_index.map((id) => {
      return { ...this.getLabels(), ...systemLabelsRecord(this.i18n) }[id]
    })
  }
}
